import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

// Placeholder team data - UPDATE WITH REAL EMPLOYEES
const teamMembers = [
  {
    id: 1,
    name: "Matt Kendall",
    role: "Founder & Master Craftsman",
    bio: "Founder &amp; President: Matt has over three decades of experience in the historic restoration business. Paired with an academic background in art, his ability to deploy traditional techniques for modern applications, exacting eye for detail, and appreciation for the unique heritage of every project ensures that every project is tackled with the utmost precision.",
    specialties: ["Stained Glass Restoration", "Lead Came Work", "Historic Preservation"],
    image: "",
    email: "matthew@vintageglassworks.com"
  }
];

const Team = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="team-page">
      {/* Hero Section */}
      <section className="team-hero section-padding-lg">
        <div className="container">
          <span className="section-label">The People Behind the Craft</span>
          <h1 className="team-hero-title">Meet Our Team</h1>
          <p className="team-hero-text">
            Our skilled craftsmen and dedicated professionals bring decades of combined 
            experience to every restoration project. Each team member shares a passion 
            for preserving architectural heritage for future generations.
          </p>
        </div>
      </section>

      {/* Team Grid */}
      <section className="team-grid-section section-padding-lg">
        <div className="container">
          <div className="row">
            {teamMembers.map((member) => (
              <div className="col-md-6 col-lg-4" key={member.id}>
                <div className="team-card hover-card-md">
                  <div className="team-card-image-wrapper img-hover-zoom">
                    <img 
                      src={member.image} 
                      alt={member.name} 
                      className="team-card-image"
                      loading="lazy"
                    />
                    <div className="team-card-overlay">
                      <a href={`mailto:${member.email}`} className="team-card-email">
                        Contact {member.name.split(' ')[0]}
                      </a>
                    </div>
                  </div>
                  <div className="team-card-content">
                    <h3 className="team-card-name">{member.name}</h3>
                    <span className="team-card-role">{member.role}</span>
                    <p className="team-card-bio">{member.bio}</p>
                    <div className="team-card-specialties">
                      {member.specialties.map((specialty, index) => (
                        <span key={index} className="team-card-specialty">
                          {specialty}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Join Our Team Section */}
      <section className="team-join-section section-padding-lg">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center">
              <span className="section-label">Careers</span>
              <h2 className="team-join-title">Join Our Team</h2>
              <div className="divider mx-auto"></div>
              <p className="team-join-text">
                Are you passionate about historic preservation and traditional craftsmanship? 
                We're always looking for skilled artisans and dedicated professionals who share 
                our commitment to quality and heritage conservation.
              </p>
              <p className="team-join-text">
                Whether you're an experienced craftsman or interested in learning traditional 
                glazing techniques through our apprenticeship program, we'd love to hear from you.
              </p>
              <Link to="/#contact" className="btn-primary-custom">
                Get In Touch
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="team-values-section section-padding-lg">
        <div className="container">
          <div className="row justify-content-center text-center mb-5">
            <div className="col-lg-8">
              <span className="section-label">What Drives Us</span>
              <h2 className="section-title">Our Values</h2>
              <div className="divider mx-auto"></div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6 col-lg-3">
              <div className="team-value-card">
                <span className="team-value-number">01</span>
                <h4 className="team-value-title">Craftsmanship</h4>
                <p className="team-value-text">
                  We take pride in mastering traditional techniques passed down through generations of artisans.
                </p>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="team-value-card">
                <span className="team-value-number">02</span>
                <h4 className="team-value-title">Preservation</h4>
                <p className="team-value-text">
                  We believe historic buildings tell stories worth preserving for future generations.
                </p>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="team-value-card">
                <span className="team-value-number">03</span>
                <h4 className="team-value-title">Integrity</h4>
                <p className="team-value-text">
                  We're honest about what can be saved and transparent about our process and pricing.
                </p>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="team-value-card">
                <span className="team-value-number">04</span>
                <h4 className="team-value-title">Education</h4>
                <p className="team-value-text">
                  We're committed to teaching traditional skills to ensure these crafts survive.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Team;